import { AutocompleteCheckboxes } from "@root/styleguide/components/inputs/autocomplete/AutocompleteCheckboxes";
import { type Control, Controller } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../../logics/resolver";
import { useModalSocialOfferFormFieldTags } from "./logics";

export const ModalSocialOfferFormFieldTags = ({ control }: { control: Control<TModalSocialOfferFormResolver> }) => {
  const { options, valueToTagValues } = useModalSocialOfferFormFieldTags();

  return (
    <Controller
      name="tags"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <AutocompleteCheckboxes
            value={valueToTagValues(value ?? [])}
            onChange={(_, newValue) => onChange(newValue.map((v) => v.value))}
            options={options}
            TextFieldProps={{ label: "Besoins *", error: Boolean(error), helperText: error?.message }}
          />
        );
      }}
    />
  );
};
